import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Invoice from 'components/Invoice'; // Path to your PDF component
import API from 'config/ApiConfig';

// constants
 // const API_BASE_URL = 'http://localhost:5000/api/admin';
 const API_BASE_URL = API.API_ADMIN
const JWT_TOKEN = localStorage.getItem('authToken');

// utility function
function getAuthHeaders() {
    return {
        'Authorization': `Bearer ${JWT_TOKEN}`,
        'Content-Type': 'application/json'
    };
}

export default function ViewPresensi() {
    const { siswaId } = useParams(); // Ambil siswaId dari useParams
    const [siswa, setSiswa] = useState({});
    const [presensi, setPresensi] = useState([]);
    const [tentors, setTentors] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sortMonth, setSortMonth] = useState('');

    useEffect(() => {
        const fetchPresensi = async () => {
            try {
                // Fetch all presensi data
                const presensiResponse = await fetch(`${API_BASE_URL}/rekap/siswa/${siswaId}`, {
                    method: 'GET',
                    headers: getAuthHeaders()
                });
                if (!presensiResponse.ok) {
                    throw new Error(`HTTP error! Status: ${presensiResponse.status}`);
                }
                const presensiData = await presensiResponse.json();

                // Filter presensi by siswaId
                const siswaPresensi = presensiData.filter(p => p.siswa_id === siswaId);

                // Fetch tentors data
                const tentorIds = [...new Set(siswaPresensi.map(p => p.tentor_id))];
                const tentorRequests = tentorIds.map(id =>
                    fetch(`${API_BASE_URL}/tentor/${id}`, {
                        method: 'GET',
                        headers: getAuthHeaders()
                    }).then(response => response.json())
                );

                const tentorData = await Promise.all(tentorRequests);
                // Convert tentorData array to object with tentor_id as keys
                const tentorsMap = tentorData.reduce((acc, tentor) => {
                    if (tentor && tentor._id) {
                        acc[tentor._id] = tentor;
                    }
                    return acc;
                }, {});

                setPresensi(siswaPresensi);
                setTentors(tentorsMap);
            } catch (error) {
                setError(error.message);
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        const fetchSiswaData = async () => {
            if (!siswaId) return;

            try {
                const response = await fetch(`${API_BASE_URL}/siswa/${siswaId}`, {
                    headers: getAuthHeaders(),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setSiswa(data);
            } catch (error) {
                console.error('Error fetching siswa details:', error);
            } finally {
                setLoading(false); // Set loading ke false setelah data diambil
            }
        };

        fetchPresensi();
        fetchSiswaData();
    }, [siswaId]);

    // Filter and sort presensi data by month
    const filteredPresensi = presensi.filter(p => {
        const month = new Date(p.waktu_pembelajaran).getMonth() + 1;
        return !sortMonth || month === parseInt(sortMonth, 10);
    }).sort((a, b) => new Date(a.waktu_pembelajaran) - new Date(b.waktu_pembelajaran));

    const monthNames = [
        'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
        'Juli', 'Agustus', 'September', 'Oktober', 'November', 'December'
    ];
    const getFileName = () => {
        const monthName = sortMonth ? monthNames[parseInt(sortMonth, 10) - 1] : 'All_Months';
        const year = new Date().getFullYear(); // or use another year source if applicable
        return `presensi_${siswa.nama || 'namasiswa'}_${monthName}_${year}.pdf`;
    };
    const firstTentorId = Object.keys(tentors)[0] || '';

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container mx-auto p-4">
            <div className="flex flex-wrap mb-4">
                <label className="mr-4 mt-2">
                    Sort by Month:
                    <select
                        className="px-2 py-1 rounded-lg shadow ml-2"
                        value={sortMonth} 
                        onChange={(e) => setSortMonth(e.target.value)}
                    >
                        <option value="" className="px-4">All</option>
                        {monthNames.map((month, index) => (
                            <option key={index} value={index + 1}>
                                {month}
                            </option>
                        ))}
                    </select>
                </label>
                <a href={`/8gy78gyug87b78iuyg767/cetak/invoice/${siswaId}/${firstTentorId}/${sortMonth? sortMonth: "all"}`}
                target="_blank">
                
                <button
                    className=" mt-2 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
                    
                >Cetak Presensi
                    {/* <PDFDownloadLink
                        document={<Invoice siswa={siswa} presensi={presensi} tentors={tentors} monthNames={monthNames} sortMonth={sortMonth} />}
                        fileName={getFileName()}
                    >
                        {({ loading }) => (loading ? 'Loading document...' : 'Cetak Presensi')}
                    </PDFDownloadLink> */}
                </button></a>
            </div>
            <div className='flex'>
                <div className="space-y-4 mb-2 mr-4">
                    <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
                    <p className="font-semibold text-blueGray-600">Nama Siswa:</p>
                    <p className="text-blueGray-600">{siswa.nama}</p>
                    </div>
                </div>
                <div>
                    {Object.keys(tentors).length > 0 && (
                        <>
                            {Object.values(tentors).map(tentor => (
                                <div key={tentor._id}>
                                    <div className="space-y-4 mb-2">
                                        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
                                        <p className="font-semibold text-blueGray-600">Nama Tentor:</p>
                                        <p className="text-blueGray-600">{tentor.nama}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </div>
            <table className="w-full bg-white border border-gray-200 rounded-lg shadow-lg">
                <thead>
                    <tr>
                        <th className="px-6 py-3 border-b border-gray-200 text-left text-sm font-medium text-gray-600">Tanggal</th>
                        <th className="px-6 py-3 border-b border-gray-200 text-left text-sm font-medium text-gray-600">Materi</th>
                        <th className="px-6 py-3 border-b border-gray-200 text-left text-sm font-medium text-gray-600">Durasi</th>
                        <th className="px-6 py-3 border-b border-gray-200 text-left text-sm font-medium text-gray-600">Ulasan</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredPresensi.map((item) => (
                        <tr key={item._id}>
                            <td className="px-6 py-4 border-b border-gray-200 text-sm text-gray-700">
                                {new Date(item.waktu_pembelajaran).toLocaleDateString()}
                            </td>
                            <td className="px-6 py-4 border-b border-gray-200 text-sm text-gray-700">
                                {item.mata_pelajaran}
                                <p>Feedback : </p>
                                <p className='ml-2'>{item.feedback}</p>
                            </td>
                            <td className="px-6 py-4 border-b border-gray-200 text-sm text-gray-700">
                                {item.durasi}
                            </td>
                            <td className="px-6 py-4 border-b border-gray-200 text-sm text-gray-700">
                                {item.ulasan}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

ViewPresensi.propTypes = {
    siswaId: PropTypes.string.isRequired,
};
